export const test = {
  data () {
    return {
    }
  },
  methods: {
    testGetRack (device, devicePlus) {
      var suma = device.oczka + devicePlus.oczka
      // console.log(device.oczka, devicePlus.oczka)
      var akum600 = this.testBatteriesShelfs(600)
      var akum800 = this.testBatteriesShelfs(800)

      // console.log(akum600.oczka, akum800.oczka)
      var suma600 = suma + akum600.oczka
      var suma800 = suma + akum800.oczka
      this.testRackCabinets(suma600, suma800)
    },
    testRackCabinets (wysokosc600, wysokosc800) {
      // console.log(wysokosc600, wysokosc800)
      var wysokosc = (wysokosc600 > wysokosc800) ? wysokosc800 : wysokosc600
      if (((50 * 3) - wysokosc) < 3) {
        this.$store.commit('app/SET_ERROR_INFO', ['brak_miejsca', true])
        // this.cofnijRuch()
      } else {
        this.$store.commit('app/SET_ERROR_INFO', ['brak_miejsca', false])
      }

      var matchSzafa600 = []
      var matchSzafa800 = []
      // matchSzafa = this.ListaSzafy.filter(item => ((item.attributes.wysokosc * 3) >= wysokosc))
      matchSzafa600 = this.ListaSzafy.filter(item => ((item.attributes.wysokosc * 3) >= wysokosc600 && Number(item.attributes.glebokosc) === Number(600)))
      matchSzafa800 = this.ListaSzafy.filter(item => ((item.attributes.wysokosc * 3) >= wysokosc800 && Number(item.attributes.glebokosc) === Number(800)))

      var wysokoscSzafy = 0
      var wolneMiejsce = 0
      var aDepth = []
      var mountRack = false

      if (matchSzafa600[0]) {
        // console.log('600', matchSzafa600[0].kod)
        mountRack = true
        this.changeValueOutputs('szafa', 'array', matchSzafa600[0])
        wysokoscSzafy = matchSzafa600[0].attributes.wysokosc
        wolneMiejsce = (wysokoscSzafy * 3) - wysokosc600
        this.changeValueOutputs('szafa_wolne_miejsce', 'value', Number(wolneMiejsce))
        for (var item600 in matchSzafa600) {
          if (matchSzafa600[item600].attributes.wysokosc === wysokoscSzafy) {
            aDepth.push(matchSzafa600[item600].attributes.glebokosc)
          }
        }
      }

      if (matchSzafa800[0]) {
        // console.log('800', matchSzafa800[0].kod)
        if (mountRack === false) {
          this.changeValueOutputs('szafa', 'array', matchSzafa800[0])
          wysokoscSzafy = matchSzafa800[0].attributes.wysokosc
          wolneMiejsce = (wysokoscSzafy * 3) - wysokosc800
          this.changeValueOutputs('szafa_wolne_miejsce', 'value', Number(wolneMiejsce))
        }

        for (var item800 in matchSzafa800) {
          if (matchSzafa800[item800].attributes.wysokosc === wysokoscSzafy) {
            aDepth.push(matchSzafa800[item800].attributes.glebokosc)
          }
        }
      }
      this.changeValueInputs('glebokosc', 'value', aDepth)
      if (aDepth.length === 1) {
        this.changeValueInputs('glebokosc_szafy', 'value', aDepth[0])
      }

      if (wysokoscSzafy > 24 && (this.inputs.panel_wentylacyjny.value === 0 || this.inputs.panel_wentylacyjny.value === '0')) {
        this.changeOther('panel_wentylacyjny', 1)
      }
      mountRack = false
    },
    testBatteriesShelfs (depth) {
      var wysokosc = 0
      var wysokoscOtw = 0
      var glebokosc = depth // this.inputs.glebokosc_szafy.value
      var allBatteries = []
      Object.keys(this.outputs.akumulators).forEach(element => {
        if (this.outputs.akumulators[element]) {
          allBatteries.push(this.outputs.akumulators[element].pojemnosc)
        }
      })
      var shelfBatteriesSmall = []
      var shelfBatteriesBig = []
      var perChunkSmall = 0 // items per chunk
      var perChunkBig = 0 // items per chunk
      var resultSmall = []
      var resultBig = []
      var allShelfs = []

      if (glebokosc === 600 || glebokosc === '600') {
        // szafa 600
        allBatteries.forEach(element => {
          if (Number(element) === 200 || Number(element) === 230) {
            shelfBatteriesBig.push(element)
          } else {
            shelfBatteriesSmall.push(element)
          }
        })

        perChunkSmall = 2 // items per chunk
        resultSmall = shelfBatteriesSmall.reduce((resultArray, item, index) => {
          const chunkIndex = Math.floor(index / perChunkSmall)
          if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [] // start a new chunk
          }
          resultArray[chunkIndex].push(item)
          return resultArray
        }, [])

        perChunkBig = 1 // items per chunk
        resultBig = shelfBatteriesBig.reduce((resultArray, item, index) => {
          const chunkIndex = Math.floor(index / perChunkBig)
          if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [] // start a new chunk
          }
          resultArray[chunkIndex].push(item)
          return resultArray
        }, [])

        if (resultSmall.length > 0 && resultSmall.length > 0) {
          allShelfs = [...resultSmall, ...resultBig]
        } else {
          if (resultSmall.length > 0) {
            allShelfs = [...resultSmall]
          }
          if (resultBig.length > 0) {
            allShelfs = [...resultBig]
          }
        }
        // console.log(allShelfs)
        // console.log('allShelfs.length: ', allShelfs.length)
      } else {
        // szafa 800
        allBatteries.forEach(element => {
          if (Number(element) === 160 || Number(element) === 200 || Number(element) === 230) {
            shelfBatteriesBig.push(element)
          } else {
            shelfBatteriesSmall.push(element)
          }
        })

        perChunkSmall = 3 // items per chunk
        resultSmall = shelfBatteriesSmall.reduce((resultArray, item, index) => {
          const chunkIndex = Math.floor(index / perChunkSmall)
          if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [] // start a new chunk
          }
          resultArray[chunkIndex].push(item)
          return resultArray
        }, [])
        var resultSmallTemp = JSON.parse(JSON.stringify(resultSmall))

        var arrResztaSmall = []
        if (resultSmallTemp && resultSmallTemp[resultSmall.length - 1] && (resultSmallTemp[resultSmall.length - 1]).length < 2) {
          arrResztaSmall = JSON.parse(JSON.stringify(resultSmallTemp[resultSmallTemp.length - 1]))
          resultSmall.pop()
        }
        if (arrResztaSmall[0]) {
          shelfBatteriesBig.push(arrResztaSmall[0])
          shelfBatteriesBig.sort()
        }

        perChunkBig = 2 // items per chunk
        resultBig = shelfBatteriesBig.reduce((resultArray, item, index) => {
          const chunkIndex = Math.floor(index / perChunkBig)
          if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [] // start a new chunk
          }
          resultArray[chunkIndex].push(item)
          return resultArray
        }, [])

        if (resultSmall.length > 0 && resultSmall.length > 0) {
          allShelfs = [...resultSmall, ...resultBig]
        } else {
          if (resultSmall.length > 0) {
            allShelfs = [...resultSmall]
          }
          if (resultBig.length > 0) {
            allShelfs = [...resultBig]
          }
        }
        // console.log(allShelfs)
        // console.log('allShelfs.length: ', allShelfs.length)
      }
      var iloscPolek = allShelfs.length

      var wysokoscAkumulatorow = iloscPolek * 7// 6
      wysokosc += wysokoscAkumulatorow
      wysokoscOtw += wysokoscAkumulatorow * 3

      return { 'wysokosc': wysokosc, 'oczka': wysokoscOtw }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/test.js